<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="payments"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :date="date"
      :sort="sort"
    ></filtered-data>
    <div class="container-fluid d-flex align-items-center my-1">
      <filter-range-date v-model="date" class="ml-auto mr-2" style="max-width: 26em;"/>
    </div>
    <template v-if="data && data.data">
    <data-table-full-height
      :data="data.data"
      :hasMore="hasMore"
      :loading="loading"
      @load-more="$refs.data.loadMore"
      @sort-change="sortChange"
      show-summary
    >
      <el-table-column prop="payment_method" label="Способ оплаты" width="300">
        <template slot-scope="{row}">
          <strong >{{row.payment_method.method}}</strong>
          <div>
            <small>
              {{row.payment_method.credentials}}
            </small>
          </div>
          <strong v-if="row.payment_method.method == '' && row.status == 'adminPay'">Пополнено администратором</strong>
        </template>
      </el-table-column>
      <table-column-date prop="created_at" sortable="custom" label="Дата и время"/>
      <table-column-number prop="value" sortable="custom" align="center" label="Сумма, руб."/>
    </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data () {
      return {
        loading: false,
        hasMore: true,
        data: {},
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        sort: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'

          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payments/history/refills.vue